import React, { Component } from 'react';
import { serverIp, firebaseAuth, toCurrency, pythonApiIp, logComponentLoad } from '../../../../config/constants.js'
import { Divider, Form, Segment, Button } from 'semantic-ui-react';
import * as UiConsts from '../../../../config/UiConstants';
import axios from 'axios';
import { SingleDatePicker } from 'react-dates';
//import { getPrintValues, getDesigners, checkAdminEmail } from '../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import { getPrintValues, checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import Select from 'react-select';
import FabricPaymentLog from './FabricPaymentLog.js';



class FabricPayment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            depositAmount: 0,
            deductAmount: 0,
            newBalance: null,
            reason: '',
            dateString: '',
            fabricDropDown: [],
            fabricName: '',
            projectId: '',
            project: '',
            shirtTypeId: '',
            totalCost: '',
            costPerMeter: '',
            fabricPaymentSourceOptions:[],
            fabricPaymentSource:'',
            
        }
    }


    componentDidMount() {
        console.log("entx8 +++++ componentDidMount - ");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");


            if (user) {


                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }


        })
    }


    setAdminResult = (returnObject) => {
        // console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "FabricPayment");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

        if (e.target.name == 'meters') {
            this.getTotalCost(e.target.value, this.state.costPerMeter);
        }
    }

    // ##########################::  FIRST :##########################:
    getInHouseFabricList = () => {
        console.log("entx1 +++++ getInHouseFabricList - ");

        this.setState({ loading: true });
        console.log("entx122 checking order numbers");


        // SEND CHECK TO SERVER
        axios.post(serverIp + 'stockPayment/getInHouseFabricList', {
            apiKey: "raw222"

        })
            .then((response) => {
                console.log("entx221 response:" + JSON.stringify(response.data, null, 3));

                console.log("entx22 result:" + response.data.result);

                // CHECK RECEIPTS
                if (response.data.result && response.data.dropdownItems) {

                    if (response.data.dropdownItems) {
                        console.log("found InHouseFabricList:" + response.data.dropdownItems.length);
                        this.setState({
                            loading: false,
                            fabricDropDown: response.data.dropdownItems
                        });
                    } else {
                        alert(" no fabric items numbers found..")
                    }


                    //alert("Success:" + response.data.message);

                    // CHECK ORDER NUMBER
                } else if (!response.data.result) {
                    alert("Error:" + response.data.message);
                    this.setState({ loading: false });
                }



            })
            .catch((error) => {
                console.log(error);
                //this.setState({ loading: false })

            });


    }

    checkProjectId = () => {
        console.log("entx1 +++++ getLargeProject - ");

        this.setState({ loading: true });
        console.log("entx122 projectId");


        // SEND CHECK TO SERVER
        axios.post(serverIp + 'large_project_items/getLargeProject', {
            apiKey: "raw222",
            projectId: this.state.projectId,
            enteredBy: this.state.user.email
        })
            .then((response) => {
                console.log("entx221 response:" + JSON.stringify(response.data, null, 3));

                console.log("entx22 result:" + response.data.result);

                // CHECK RECEIPTS
                if (response.data.result && response.data.largeProject) {

                    if (response.data.largeProject) {
                        console.log("found largeProject:" + response.data.largeProject.name);

                        this.setState({
                            loading: false,
                            project: response.data.largeProject
                        });

                        //LOAD ITEM LIST
                        if (this.state.algoliaUser && this.state.algoliaUser.perms.includes("enterFabricPayment")) {
                            this.getInHouseFabricList();
                            //1. GET MAIN CARD OBJECTS FROM ALGOLIA
                            getPrintValues("fabricPaymentSource", this.loadOptions);
                        }

                        alert("Found Project:" + response.data.largeProject.name)
                    } else {
                        alert(" no project found with id:" + this.state.projectId)
                    }


                    //alert("Success:" + response.data.message);

                    // CHECK ORDER NUMBER
                } else if (!response.data.result) {
                    alert("Error:" + response.data.message);
                    this.setState({ loading: false });
                }

            })
            .catch((error) => {
                console.log(error);
                //this.setState({ loading: false })

            });


    }

    loadOptions = (displayTypes) => {
        console.log("shtx18 ++++++ load display Types ");
        console.log("shtx18 deposit_source:" + JSON.stringify(displayTypes, null, 3));
        this.setState({ fabricPaymentSourceOptions: displayTypes })
    }


    enterFabricPayment = () => {
        console.log("entx1 +++++ enterFabricPayment - ");

        if (this.state.project == '') {
            alert("please enter Project ");
        } else if (this.state.meters == '') {
            alert("please enter meters");
        } else if (this.state.fabricPaymentSource == '') {
            alert("please enter how payment was sent");
        } else if (this.state.fabricName == '') {
            alert("please enter how payment was sent");
        } else if (this.state.shirtTypeId == '') {
            alert("please enter shirtTypeId");
        } else if (this.state.fabricName == '') {
            alert("please select Item");
        }  else if (this.state.dateSent == '' || this.state.dateSent == null) {
            alert("please enter  dateSent");
        } else {

            this.setState({ loading: true });
            // SEND CHECK TO SERVER
            axios.post(serverIp + 'stockPayment/enterFabricPayment', {
                apiKey: "enterFabricPayment",
                projectId: this.state.project.idlargeProjects,
                enteredBy: this.state.user.email,
                meters: this.state.meters,
                projectName: this.state.project.name,
                enteredItemNumber: this.state.fabricName,
                dateSent: this.state.dateSent,
                shirtTypeId: this.state.shirtTypeId,
                notes: this.state.notes,
                fabricPaymentSource: this.state.fabricPaymentSource,
                paymentReference: this.state.paymentReference
            })
                .then((response) => {
                    console.log("entx221 response:" + JSON.stringify(response.data, null, 3));

                    console.log("entx22 result:" + response.data.result);

                    // CHECK RECEIPTS
                    if (response.data.result) {

                        this.setState({
                            loading: false,
                        });

                        alert(response.data.message);
                        this.clearFields();

                    } else if (!response.data.result) {
                        alert("Error:" + response.data.message);
                        this.setState({ loading: false });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }

    dateSelectOnChange = (date) => {
        console.log("+++++++:dateSelectOnChange");
        console.log("date sent:" + date)
        console.log("dateString:" + date.format('dddd MMMM Do'));
        this.setState({
            selectedDate: date.valueOf(),
            dateString: date.format('dddd MMMM Do'),
            dateSent: date.valueOf()
        })

        console.log(date.valueOf());
    }

    clearFields = () => {

        this.setState({
            loading: false,
            projectId: '',
            enteredBy: this.state.user.email,
            meters: '',
            project: '',
            projectName: '',
            enteredItemNumber: '',
            dateSent: null,
            shirtTypeId: undefined,
            notes: '',
            totalCost: '',
            fabricPaymentSource: '',
            dateString: '',
            fabricName: ''
        })
    }

    handleDropDownChanges = (value) => {
        console.log("docx19 handleDropDownChanges");
        console.log('docx191 You\'ve sss:', value);
        console.log("docx192 category alone:" + value.category);
        console.log('docx193 You\'ve selected:', value.value + " " + value.category);
        console.log("docx195 - costPerMeter:" + value.rate);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        if(value.category == 'shirtTypeId'){
            newState['fabricName'] = value.label;
            newState['costPerMeter'] = value.rate;
        }
       

        //this.setState(newState);
        this.setState(newState);
    }

    getTotalCost = (meters, costPer) => {
        console.log("+++++ getTotalCost");
        console.log("meters:" + meters);
        console.log("costPerMeter:" + costPer);
        let totalCost = meters * costPer;
        console.log("totalCost:" + totalCost);

        this.setState({
            totalCost: totalCost
        })
    }

  

    render() {

        const totalCostUi = this.state.totalCost != ''
            ? <div><label>Total Cost: {toCurrency(this.state.totalCost)}</label></div>
            : ''

        const enterPaymentUi = this.state.project != ''
            ? <div>

                <Divider horizontal>{'STEP 2. ENTER FABRIC PAYMENT'}</Divider>
                <h4>PROJECT: {this.state.project.name}</h4>

                <Form size='large' onSubmit={this.enterFabricPayment}>
                    <Segment stacked>

                        <label>Date Payment Was Sent</label>
                        <br />
                        <SingleDatePicker
                            date={this.state.date} // momentPropTypes.momentObj or null
                            //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                            onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused} // PropTypes.bool
                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                            isOutsideRange={() => false}
                        />
                        <h3>{this.state.dateString}</h3>

                        <label> ITEM CODE {this.state.fabricName} </label>
                        <br />
                        <label> Start Typing the code to help select faster </label>
                        <Select
                            name="form-field-name"
                            value={this.state.shirtTypeId}
                            options={this.state.fabricDropDown}
                            onChange={this.handleDropDownChanges}
                            searchable={true}
                            clearable={false}
                        />

                        <br />
                        {/* Num. Of Meters*/}
                        <Form.Field>
                            <label>Num. Of Meters</label>
                            <br />
                            {totalCostUi}
                            <Form.Input
                                fluid
                                name={'meters'}
                                value={this.state.meters}
                                icon='add user'
                                iconPosition='left'
                                placeholder='Num. Of Meters'
                                // onFocus={props.amp_logFieldClick}
                                onChange={this.handleTextInputChange}
                                type='number' />
                        </Form.Field>

                        <label> How Payment was sent  </label>
                        <Select
                            name="form-field-name"
                            value={this.state.fabricPaymentSource}
                            options={this.state.fabricPaymentSourceOptions}
                            onChange={this.handleDropDownChanges}
                            searchable={true}
                            clearable={false}
                        />

                        {/* notes*/}
                        <Form.Field>
                            <label>Payment Reference (If Payment Made)</label>
                            <Form.Input
                                fluid
                                name={'paymentReference'}
                                value={this.state.paymentReference}
                                icon='add user'
                                iconPosition='left'
                                placeholder='Payment reference if avail e.g req# or mm trans id'
                                onChange={this.handleTextInputChange}
                                type='text' />
                        </Form.Field>

                        {/* notes*/}
                        <Form.Field>
                            <label>notes</label>
                            <Form.Input
                                fluid
                                name={'notes'}
                                value={this.state.notes}
                                icon='add user'
                                iconPosition='left'
                                placeholder='reason'
                                onChange={this.handleTextInputChange}
                                type='text' />
                        </Form.Field>

                        <Button color='blue' fluid size='large'>SEND</Button>
                    </Segment>
                </Form>

            </div>
            : ''

        const wholeUI = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.perms.includes("enterFabricPayment")
            ? <div>

                <Form size='large' onSubmit={this.checkProjectId}>
                    <Segment stacked>

                        {/* CHECK PROJECT ID */}
                        <Divider horizontal>{'STEP 1. CHECK PROJECT ID'}</Divider>
                        <Form.Field>
                            <label>Project Id</label>
                            <Form.Input
                                fluid
                                name={'projectId'}
                                value={this.state.projectId}
                                icon='add user'
                                iconPosition='left'
                                placeholder='enter project id'
                                onChange={this.handleTextInputChange}
                                type='number' />
                        </Form.Field>
                        <Button color='green' fluid size='large'>Check Id</Button>
                    </Segment>
                </Form>

                {/* ENTER PAYMENT AFTER PROJECT ID CHECK */}
                {enterPaymentUi}

            </div>
            : <h2>YOU ARE NOT AN AUTHORIZED</h2>


        return (
            this.state.loading ? <UiConsts.LoadingComponent /> :
                <div>
                    <h1>Enter In House fabric Payment</h1>
                    {wholeUI}
                    <FabricPaymentLog />
                </div>
        );
    }
}

export default FabricPayment;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/StockPayment/FabricPayment.js